import React from 'react';
//PROVEEDORES DE DATA
import { Provider } from 'react-redux';
import store from './redux-app/store';

//PROVEEDORES DE INTERFAZ GRAFICA
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import theme from './theme';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
import { ToastContainer } from 'react-toastify';

//APLICACION DATA SERVICE
import {CustomApolloProvider} from './components';
import AppDS from './AppDS';

//ESTILOS GLOBALES
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/index.scss';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <CustomApolloProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
              <AppDS />
              <ToastContainer
                position='bottom-left'
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                limit={5}
              />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </CustomApolloProvider>
    </Provider>
  );
}

export default App;
